const SITE_URL = 'https://timothyd.site';

const getBaseUrl = () => {
  const configured = String(
    process.env.REACT_APP_SITE_URL || process.env.PUBLIC_URL || '',
  ).trim();

  if (/^https?:\/\//i.test(configured)) {
    return configured.replace(/\/+$/, '');
  }

  return SITE_URL;
};

export const DEFAULT_ROBOTS = 'index,follow';
export const NOINDEX_ROBOTS = 'noindex,nofollow';

export const buildAbsoluteUrl = (path = '/') => {
  if (/^https?:\/\//i.test(path)) {
    return path.replace(/\/+$/, '');
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return new URL(normalizedPath, `${getBaseUrl()}/`).toString();
};

const routeSeo = {
  home: {
    description:
      "Timothy Demonbreun's personal website. Belmont University alumni.",
    canonicalPath: '/',
    robots: DEFAULT_ROBOTS,
  },
  about: {
    title: 'About',
    description: 'Learn about Timothy Demonbreun.',
    canonicalPath: '/about',
    robots: DEFAULT_ROBOTS,
  },
  contact: {
    title: 'Contact',
    description: 'Contact Timothy Demonbreun via email at m@timothyd.site.',
    canonicalPath: '/contact',
    robots: DEFAULT_ROBOTS,
  },
  notFound: {
    title: '404 Not Found',
    description: 'The content you are looking for cannot be found.',
    canonicalPath: '/404',
    robots: NOINDEX_ROBOTS,
  },
  projects: {
    title: 'Projects',
    description: "Learn about Timothy Demonbreun's projects.",
    canonicalPath: '/projects',
    robots: DEFAULT_ROBOTS,
  },
  resume: {
    title: 'Resume',
    description: "Timothy Demonbreun's resume.",
    canonicalPath: '/resume',
    robots: DEFAULT_ROBOTS,
  },
  stats: {
    title: 'Stats',
    description: 'Site statistics for Timothy Demonbreun.',
    canonicalPath: '/stats',
    robots: DEFAULT_ROBOTS,
  },
  upwork: {
    title: 'Upwork Profile',
    description:
      'Full-stack software development, cloud architecture, AI, and DevOps by Timothy Demonbreun.',
    canonicalPath: '/upwork',
    robots: DEFAULT_ROBOTS,
  },
  upworkProjects: {
    title: 'Upwork Portfolio Projects',
    description:
      'Small-business AWS, messaging, storage, email delivery, and infrastructure monitoring projects by Timothy Demonbreun.',
    canonicalPath: '/upwork/projects',
    robots: DEFAULT_ROBOTS,
  },
};

export default routeSeo;
